import * as housingResultActions from './actions'


export { housingResultActions }
export * from './action-types'
export { getHousingResult } from './selectors'
export { housingResultReducer } from './reducer'
export { HousingResult } from './housing-result'


// WEBPACK FOOTER //
// ./src/core/housing-result/index.js